import { APIService } from '../api/APIService'
import { AuthService } from '../api/AuthService'

import {
  LOGIN,
  LOGOUT,
  REGISTER,
  FORGOT_PASSWORD,
  UPDATE_USER,
  UPDATE_USER_REQUEST_ACCESS_DATE,
  ASSIGN_CURRENT_USER,
  ASSIGN_CURRENT_COMPANY
} from './types/actions.type'

import {
  SET_AUTH,
  SET_USER,
  SET_COMPANY,
  PURGE_AUTH,
  SET_ERROR,
  SET_LOADING,
  SET_REGISTER_FIELDS
} from './types/mutations.type'

const api = new APIService()
const auth = new AuthService()

const state = {
  errors: null,
  user: {},
  company: {},
  registerFields: {},
  isAuthenticated: auth.isAuthenticated(),
  isLoading: false
}

const getters = {
  currentUser(state) {
    return state.user
  },
  currentCompany(state) {
    return state.company
  },
  registerFields(state){
    return state.registerFields
  },
  isAuthenticated(state) {
    return state.isAuthenticated
  },
  isRequestInProgress(state){
    return state.isLoading
  },
  fetchError(state){
    return state.errors
  },
  fetchResponse(state) {
    return state.message
  }
}

const actions = {
  [LOGIN](context, fields) {
    context.commit(SET_LOADING, true)
    context.commit(SET_ERROR, null)
    return new Promise(resolve => {
      auth.login(fields).then(data => {
        context.commit(SET_LOADING, false)
        if(data.error) {
          context.commit(SET_ERROR, data.error_description)
        } else {
          context.commit(SET_AUTH, data)
          resolve(data)
        }
      }).catch(err => {
        context.commit(SET_LOADING, false)
        context.commit(SET_ERROR, err)
      })
    })
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH)
  },
  [REGISTER](context, fields) {
    context.commit(SET_REGISTER_FIELDS, fields)
    context.commit(SET_LOADING, true)
    context.commit(SET_ERROR, null)

    return new Promise((resolve, reject) => {
      api.createAccount(fields).then(data => {
        context.commit(SET_LOADING, false)
        if(data.statusCode === 400) {
          if (data.code === 'invalid_password') {
            var policyStr = ''
            if(data.policy) policyStr = data.policy.replace(/\*/g, '<br /> *')

            const errMessage = data.policy ? data.message + policyStr.substring(0, 244) + '*)' : data.message
            context.commit(SET_ERROR, {
              error: errMessage, error_type: 'password', account: fields.account_type
            })
          }
          else if (data.code === 'username_exists' ||
              data.code === 'user_exists' ||
              data.code === 'invalid_signup') {
            const type = data.code === 'username_exists' ? 'username' : 'email'
            context.commit(SET_ERROR, {
              error: data.description, error_type: type, account: fields.account_type
            })
          }
          else if (data.errorCode){
            const type = 'misc'
            context.commit(SET_ERROR, {
              error: data.message, error_type: type, account: fields.account_type
            })
          }
        } else {
          context.commit(SET_USER, data)
          context.commit(SET_AUTH, data)
          context.commit(SET_ERROR, null)
          resolve(data)
        }
      }).catch(err => {
        context.commit(SET_LOADING, false)
        context.commit(SET_ERROR, err )
      })
    })
  },
  async [FORGOT_PASSWORD](context, fields) {
    context.commit(SET_LOADING, true)
    context.commit(SET_ERROR, '')

    try {
      const changePass = await auth.changePassword(fields)
      context.commit(SET_LOADING, false)
      if(changePass.response_code === 'SC00') return changePass
      else context.commit(SET_ERROR, changePass.error_description)
    } catch(err) {
      context.commit(SET_LOADING, false)
      context.commit(SET_ERROR, err)
    }
  },
  [UPDATE_USER](context, payload) {},
  [UPDATE_USER_REQUEST_ACCESS_DATE](context, id) {
    context.commit(SET_LOADING, true)
    return new Promise(resolve => {
      const field = { is_accessed: true }
      api.updateUserRequestAccessDate(id, field).then(data => {
        context.commit(SET_LOADING, false)
        if(data.statusCode === 400) {
          context.commit(SET_ERROR, data.message)
        } else {
          resolve(data)
        }
      }).catch(err => {
        context.commit(SET_LOADING, false)
        context.commit(SET_ERROR, err)
      })

    })
  },
  [ASSIGN_CURRENT_USER](context, payload) {
    context.commit(SET_USER, payload)
  },
  [ASSIGN_CURRENT_COMPANY](context, payload) {
    context.commit(SET_COMPANY, payload)
  }
}

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error
  },
  [SET_LOADING](state, loading) {
    state.isLoading = loading
  },
  [SET_REGISTER_FIELDS](state, fields) {
    state.registerFields = fields
  },
  [SET_USER](state, user) {
    state.user = user
    state.errors = null
  },
  [SET_COMPANY](state, company) {
    state.company = company
    state.errors = null
  },
  [SET_AUTH](state, user) {
    state.isAuthenticated = true
    state.user = user
    state.errors = null
    auth.setSession(user)
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false
    state.user = {}
    state.company = {}
    state.errors = null
    auth.logout()
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/auth.module.js